module.exports = __webpack_public_path__ + "static/media/Program14.a5e545cb.jpg";